import { render, staticRenderFns } from "./superadmin-options-form.vue?vue&type=template&id=9283c372&scoped=true&"
import script from "./superadmin-options-form.vue?vue&type=script&lang=ts&"
export * from "./superadmin-options-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9283c372",
  null
  
)

export default component.exports